// eslint-disable-next-line import/no-anonymous-default-export
import {
    SATIS_TIPI_ST_TUR,
    SATIS_TIPI_GROUPS,
    SATIS_TIPI_ALIASES,
    KNOWN_CAS_TIPS,
    casTipFromAlias,
    getSatisTipiByCasTip,
    getIslemStTur,
    getSatisTuruStTur,
    getPaketStTur,
    isKnownCasTip,
    isEkimCasTip,
    getStTurByAlias,
    buildAliasStTurMap,
} from './utils/satisTipiSabit.js';

export default {
    FIRMALkp: [],
    KULLANICILkp: [],
    KULLANICISECIMLkp: [],
    sabitLkp: [],
    sabitgrupLkp: [],
    EKRANLkp: [],
    ROLLkp: [],
    HAKLkp: [],
    dictLkp: [],
    langLkp: [],
    themeLkp: [],
    ULKELkp: [],
    ILLkp: [],
    ILCELkp: [],
    meslekLkp: [],
    not1Lkp: [],
    not2Lkp: [],
    BAGLANTILARLkp: [],
    macLkp: [],
    islemsablonLkp: { detay: [], baslik: [] },

    KULLANICI: {
    },

    /** SABIT ST_TUR = 127 (Satış Tipi) */
    satisTipiStTur: SATIS_TIPI_ST_TUR,

    /**
     * Tam eşleme (CAS_TIP → satış türü / paket / işlem ST_TUR).
     * Örnek: satisTipiGruplari[1].satisTuru === 19
     */
    satisTipiGruplari: SATIS_TIPI_GROUPS,

  /**
   * CAS_TIP (ST_TUR=127 ST_KODINT) — takma adlar.
   * satistipi.ekim === 1, satistipi.ekpaket === 2, ...
   */
    satistipi: { ...SATIS_TIPI_ALIASES },

    /**
     * İşlem / paket içeriği ST_TUR (IslemPanel CI_TUR).
     * Eski adı satistipigrubu; değerler 126, 123, 124, 125, 142, 145.
     */
    satistipigrubu: buildAliasStTurMap('islem'),

    /**
     * Satış türü ST_TUR (CAS_SATIS_TURU lookup).
     * 19, 135, 136, 137, 140, 143
     */
    satisTuruGrubu: buildAliasStTurMap('satisTuru'),

    /**
     * Satış paketi ST_TUR (CAS_SAT_PAKET_REF lookup).
     * 21, 131, 132, 133, 141, 144
     */
    satisPaketGrubu: buildAliasStTurMap('paket'),

    /** Ekim/Kanal/Alımcı işlem türü (CARI_EKIMKANALALIM.CE_TUR) — SABIT ST_TUR=110, satış tipinden bağımsız */
    ekimKanalCeTurStTur: 110,

    knownCasTipleri: KNOWN_CAS_TIPS,

    casTipFromAlias,
    getSatisTipiByCasTip,
    getIslemStTur,
    getSatisTuruStTur,
    getPaketStTur,
    isKnownCasTip,
    isEkimCasTip,
    getStTurByAlias,

    // String Length Validasyon Kuralları
    stringValidations: {
        CARI_KART: {
            CAR_ADSOY: 50,
            CAR_GSM: 15,
            CAR_TEL1: 15,
            CAR_TEL2: 15,
            CAR_MAIL: 100,
            CAR_ADRES: 300,
            CAR_WEB: 100,
            CAR_NOT: 2147483647,
            CAR_ACK: 2147483647,
            CAR_KRON_HAS: 2147483647,
            CAR_KUL_ILAC: 2147483647,
            CAR_AML_OPS: 2147483647,
            CAR_OZ_GECMIS: 2147483647,
            CAR_SAC_DER_HAS: 2147483647,
            CAR_SAC_ANALIZ: 2147483647,
            CAR_TC: 11,
            MUSCEVAP1: 50,
            MUSCEVAP2: 50,
            MUSCEVAP3: 50,
        },
        CARI_DETAY: {
            CD_ACK: 1000
        },
        CARI_ISLEM: {
            CI_ACK: 1000
        },
        CARI_PARA: {
            CP_ACK: 1000
        },
        CARI_EKIMKANALALIM: {
            CE_ACK: 2147483647
        },
        CARI_SATIS: {
            CAS_NOT: 2147483647
        },
        KULLANICI: {
            KUL_ADI: 50,
            KUL_MAIL: 100,
            KUL_AD: 50,
            KUL_SOYAD: 50
        },
        SABIT: {
            ST_AD: 100,
            ST_ACIKLAMA: 500
        },
        MESLEK: {
            MES_ADI: 100
        }
    },

    getMaxLength: function(modelName, fieldName) {
        return this.stringValidations[modelName]?.[fieldName] || null;
    },

    isRequired: function(modelName, fieldName) {
        const requiredFields = {
            CARI_KART: ['CAR_ADSOY'],
            CARI_SATIS: ['CAS_TIP', 'CAS_SATIS_TUT_TAR'],
        };

        return requiredFields[modelName]?.includes(fieldName) || false;
    }

}
